import axios from "axios";

export const appAxios = axios.create({
  baseURL: process.env.VUE_APP_PROD_LOCAL_API_URL,
  timeout: 120000, //ms
  headers: {
    "Content-Type": "application/json",
  },
});
